import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDeezerComponent } from './simple-icons-deezer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDeezerComponent ],
    exports:      [ SimpleIconsDeezerComponent ],
    bootstrap:    []
})
export class SimpleIconsDeezerModule {}
